import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertProductTestQuery from './query.graphql';

const ExpertProductTest = loadable(
  () => import(/* webpackChunkName: "expert" */ './product-test'),
  {
    fallback: <Loader />,
  }
);

ExpertProductTest.graphQL = expertProductTestQuery;

ExpertProductTest.variables = ({ slug }) => ({
  slug,
});

export default ExpertProductTest;
